import * as React from 'react';
import styled from "styled-components";
import Assets from "../../../assets/img/assets";
import HeadlineLarge from "../../../common/atom/text/headline_large";
import {ConstBreakPoint, ConstColor} from "../../../../config/styles_const/styles_const";
import Paragraph from "../../../common/atom/text/paragraph";
import {Link} from "react-router-dom";

interface IProps {
    isLafoolMedical: boolean;
}

const AuthApplyClientLafoolRegisterSide: React.FC<IProps> = (props) => {
    const { isLafoolMedical } = props;

    return (
        <Wrapper>
            <CreateFormTitle>
                法人向け新規登録
            </CreateFormTitle>
            <WelcomeTextWrapper>
                {isLafoolMedical ?
                    <Paragraph>
                        Lafool Medicalからの訪問ありがとうございます。 はじめてのご利用には新規登録(無料)が必要になります。
                    </Paragraph>
                    :
                    <Paragraph>
                        Lafool Surveyからの訪問ありがとうございます。 はじめてのご利用には新規登録(無料)が必要になります。
                    </Paragraph>
                }
            </WelcomeTextWrapper>
            <LinkParagraph>
                アカウントをお持ちの方は
                <Link to={`/login`}>こちら</Link>
                よりログインしてください。
            </LinkParagraph>
            <CreateFormImgCenterWrapper>
                <CreateFormImg src={Assets.lafool_expertnetwork} />
            </CreateFormImgCenterWrapper>
        </Wrapper>
    )

};

export default AuthApplyClientLafoolRegisterSide;

const Wrapper = styled.div`
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-right: 20px;
        width: 50%;
    }   
`;

const WelcomeTextWrapper = styled.div`
    margin-bottom: 15px;
`

const LinkParagraph = styled(Paragraph)`
    & a { 
        color: ${ConstColor.Corporate};
    }
`
const CreateFormImgCenterWrapper = styled.div`
    margin-right: auto;
    margin-left: auto;
    
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-right: 0;
        margin-left: 0;
        height: 60%;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }
`;

const CreateFormTitle = styled(HeadlineLarge)`
    text-align: center;
    margin-bottom: 30px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        text-align: left;
    }    
`;

const CreateFormImg = styled.img`
    margin-bottom: 30px;    
`;


// WEBPACK FOOTER //
// ./src/presentation/component/auth/apply_client_lafool_register/auth_apply_client_lafool_register_side.tsx